import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class EmailMessageService {
  private readonly _http = inject(HttpClient);

  private readonly _apiUrl = environment.apiUrl;

  // @GET: PERSONAL EMAIL APIS

  getPersonalInbox() {
    return this._http.get(`${this._apiUrl}/message/get-inbox`);
  }

  getPersonalStarred() {
    return this._http.get(`${this._apiUrl}/message/get-starred`);
  }

  getPersonalSent() {
    return this._http.get(`${this._apiUrl}/message/get-sent`);
  }

  getPersonalDraft() {
    return this._http.get(`${this._apiUrl}/message/get-draft`);
  }

  getPersonalAllMail() {
    return this._http.get(`${this._apiUrl}/message/get-all-mail`);
  }

  getPersonalTrash() {
    return this._http.get(`${this._apiUrl}/message/get-trash`);
  }

  // @GET: CLUB EMAIL APIS

  getClubInbox() {
    return this._http.get(`${this._apiUrl}/message/get-club-inbox`);
  }

  getClubStarred() {
    return this._http.get(`${this._apiUrl}/message/get-club-starred`);
  }

  getClubSent() {
    return this._http.get(`${this._apiUrl}/message/get-club-sent`);
  }

  getClubDraft() {
    return this._http.get(`${this._apiUrl}/message/get-club-draft`);
  }

  getClubAllMail() {
    return this._http.get(`${this._apiUrl}/message/get-club-allmails`);
  }

  getClubTrash() {
    return this._http.get(`${this._apiUrl}/message/get-club-trash`);
  }

  // @GET: GROUP EMAIL APIS

  getGroupInbox() {
    return this._http.get(`${this._apiUrl}/message/get-group-inbox`);
  }

  getGroupStarred() {
    return this._http.get(`${this._apiUrl}/message/get-group-starred`);
  }

  getGroupSent() {
    return this._http.get(`${this._apiUrl}/message/get-group-sent`);
  }

  getGroupDraft() {
    return this._http.get(`${this._apiUrl}/message/get-group-draft`);
  }

  getGroupAllMail() {
    return this._http.get(`${this._apiUrl}/message/get-group-allmails`);
  }

  getGroupTrash() {
    return this._http.get(`${this._apiUrl}/message/get-group-trash`);
  }

  // Other APIs

  moveMessage(data: { esdb_id: string; id: number; to: string }) {
    return this._http.post(`${this._apiUrl}/message/move`, data);
  }

  readMessage(id: number) {
    return this._http.get(`${this._apiUrl}/message/read-message/${id}`);
  }

  deleteDraft(id: number) {
    return this._http.delete(`${this._apiUrl}/message/delete-draft/${id}`);
  }

  deleteMessage(esDbId: string) {
    return this._http.delete(`${this._apiUrl}/message/deny-message/${esDbId}`);
  }

  sendPersonalMessage(formData: FormData) {
    return this._http.post(`${this._apiUrl}/message/send`, formData);
  }

  sendGroupMessage(formData: FormData) {
    return this._http.post(`${this._apiUrl}/message/send-group-message`, formData);
  }

  sendClubMessage(formData: FormData) {
    return this._http.post(`${this._apiUrl}/message/send-club-message`, formData);
  }

  replyMessage(esDbId: string, formData: FormData) {
    return this._http.post(`${this._apiUrl}/message/reply/${esDbId}`, formData);
  }

  replyToAllMessage(esDbId: string, formData: FormData) {
    return this._http.post(`${this._apiUrl}/message/reply-to-all/${esDbId}`, formData);
  }

  markAsRead() {
    return this._http.get(`${this._apiUrl}/mark-as-read/messages`);
  }
}
